import type { FunctionalGrid } from '../overmind/calculation/grid/FunctionalGrid';

export function selectExternalNetworkInjection(functionalGrid: FunctionalGrid) {
  // This function should be used in medium voltage calculations
  // Requirements how to handle multiple external network injections are not delivered, so currently we work on the first
  return functionalGrid.externalNetworkInjections[0];
}
